import { Link } from 'react-router-dom';
import { topicList } from '@/mocks/news';
import { mediaList } from '@/mocks/movies';

export default function TopicSection() {
  return (
    <section>
      <div className="mb-4 flex flex-wrap items-end justify-between gap-2">
        <div className="flex items-end gap-3">
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">主题专题集合</h2>
          <p className="pb-1 text-xs text-foreground-500">按主题打包的好片单</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {topicList.map((topic, index) => {
          const first = mediaList.find((item) => item.id === topic.mediaIds[0]);
          return (
            <Link
              key={topic.id}
              to={`/topic/${topic.id}`}
              style={{ animationDelay: `${index * 60}ms` }}
              className="group animate-fade-up overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300"
            >
              <div className="relative h-[150px] w-full overflow-hidden bg-background-800">
                <img
                  src={topic.cover}
                  alt={`${topic.title} 专题封面`}
                  title={`${topic.title} 影视专题`}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 to-background-950/10" />
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <p className="text-[10px] tracking-[0.18em] text-accent-300">{topic.subtitle}</p>
                  <h3 className="mt-1 font-heading text-base font-bold text-background-50">{topic.title}</h3>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4">
                {first && (
                  <div className="h-16 w-11 shrink-0 overflow-hidden rounded bg-background-200">
                    <img src={first.poster} alt={first.title} title={first.title} className="h-full w-full object-cover" />
                  </div>
                )}
                <div className="min-w-0 flex-1">
                  <p className="line-clamp-2 text-[11px] leading-relaxed text-foreground-600">{topic.description}</p>
                  <p className="mt-2 flex items-center gap-1 text-[11px] font-medium text-primary-700">
                    查看专题
                    <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}